/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Eye = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 13" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M11 0C4 0 0 5.11 0 6.5S4 13 11 13s11-5.11 11-6.5S18 0 11 0zM5.82 10.07a9.58 9.58 0 0 1-4-3.57 9.58 9.58 0 0 1 4-3.57 5.95 5.95 0 0 0 0 7.14zm5.18.85A4.53 4.53 0 0 1 6.38 6.5 4.53 4.53 0 0 1 11 2.08a4.53 4.53 0 0 1 4.61 4.42A4.52 4.52 0 0 1 11 10.92zm5.18-.85a6 6 0 0 0 0-7.14 9.72 9.72 0 0 1 4 3.57 9.72 9.72 0 0 1-4 3.57zM11 4.66A1.88 1.88 0 0 0 9.09 6.5a1.91 1.91 0 0 0 3.81 0A1.87 1.87 0 0 0 11 4.66z" />
      </g>
    </svg>
  </span>
);

Eye.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Eye.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Eye;
